var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiometricId(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.375,
    height: 64.375,
    viewBox: "0 0 64.375 64.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "biometric-icon",
    transform: "translate(-3 -0.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Export",
    transform: "translate(3 0.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13252",
    "data-name": "Path 13252",
    d: "M0,0H64V64",
    fill: "#fff",
    stroke: "#202020",
    strokeWidth: 0.75,
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_20",
    "data-name": "Layer 20",
    transform: "translate(13.602 11.726)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9902",
    "data-name": "Rectangle 9902",
    width: 51.45,
    height: 42.322,
    rx: 16,
    transform: "translate(-4.54 -0.887)",
    fill: "#deebfe",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24737",
    "data-name": "Group 24737",
    transform: "translate(-4.54 1.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24736",
    "data-name": "Group 24736",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24735",
    "data-name": "Group 24735",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137601",
    "data-name": "Path 137601",
    d: "M56.751,23.5l-.21,1.387L56.3,26.5l-2.192,14.7A2.657,2.657,0,0,1,51.1,43.423L24.524,39.449l-6.233-.935L9.993,37.3a2.634,2.634,0,0,1-2.221-3L11.566,8.837a2.649,2.649,0,0,1,3-2.221L45.235,11.2l5.8.865,4.675.694a2.649,2.649,0,0,1,2.221,3l-.514,3.429",
    transform: "translate(-6.945 -5.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137602",
    "data-name": "Path 137602",
    d: "M39.78,24.065c.062-.039.056,0,.117-.062v.056h.063a.078.078,0,0,0-.086-.07v-.039C39.873,23.909,39.788,23.986,39.78,24.065Z",
    transform: "translate(-14.019 -9.634)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137603",
    "data-name": "Path 137603",
    d: "M39.44,23.8Z",
    transform: "translate(-13.944 -9.603)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137604",
    "data-name": "Path 137604",
    d: "M42.41,24.643a.117.117,0,0,1,0-.056C42.4,24.627,42.341,24.635,42.41,24.643Z",
    transform: "translate(-14.593 -9.777)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137605",
    "data-name": "Path 137605",
    d: "M39.44,23.78Z",
    transform: "translate(-13.944 -9.599)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137606",
    "data-name": "Path 137606",
    d: "M46.209,23.08a.07.07,0,0,0,0,.047h0Z",
    transform: "translate(-15.438 -9.444)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137607",
    "data-name": "Path 137607",
    d: "M42.91,22.8Z",
    transform: "translate(-14.71 -9.382)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137608",
    "data-name": "Path 137608",
    d: "M39.289,23.04c0,.109.109.109.164.179s-.07,0-.07,0a.125.125,0,0,0,.056.125h0s.07,0,.078.047h-.085a1.2,1.2,0,0,0,.148.062h-.085a.242.242,0,0,0,.125.047c-.056,0,0-.056,0-.07h0c.047-.1-.109-.078-.148-.148h.07a.562.562,0,0,0,.382.242h0v.156h.056a.148.148,0,0,0,.047.117l.078-.047V23.8h-.141c0,.047.056,0,.086,0a.109.109,0,0,0,0,.056l.078-.078v-.008c0-.016,0,.078.056.047a.047.047,0,0,1,0,.047s.093,0,.117-.047.117,0,.1.093a.133.133,0,0,1,.1-.062c-.078.093.109,0,.078.133.056-.085.156,0,.242-.056h0s.047.039.07.062.086-.085.133-.125c0,.078-.047.085-.047.156,0-.062.1-.047.093-.1s0,0,0,.093c0-.093,0,0,.078-.062s0,.085.07.07v-.085c0-.031,0,.056.047.1s.093-.078.133-.07h0a.593.593,0,0,0,.218-.039.187.187,0,0,1,0-.093h.062c0,.07-.047,0-.056.062s.141-.056.179,0-.109,0-.056.07h-.07v.1c0,.1.109,0,.2,0s0-.056,0-.085.07.179.179.109.056-.125.117-.07v.07c.085,0,.07-.1.148-.039s-.07,0-.056,0,.047-.039.093,0v.062h.3c.1,0,0,.039,0,.062a.731.731,0,0,1,.4.109l.056-.056h0a.382.382,0,0,1,.343,0h0c.07,0,.093-.109.156-.047h0c.156.047.327,0,.436.117,0-.085.148.056.169-.062.078.07.056.085.171.141s.062-.062.1-.07v.056l.062-.056v.078h0a.062.062,0,0,1,0-.056.141.141,0,0,1,.141.093h.15l-.056.039c-.056.039,0,.062.086,0s0,0,0-.047.109.056.164.047v.039h.343c-.039,0,0-.093,0-.093v.062s-.039,0,0-.07,0,.078,0,.093h.056v.047c0,.047.085.078.125,0h.273c.093,0,.047,0,.078-.078a.717.717,0,0,0,.225.085c.062,0,0-.039.056-.07s.085.056,0,.085a.553.553,0,0,0,.337-.07s-.047,0-.047-.039.078,0,.078,0h0a2.1,2.1,0,0,1,.3-.156c.1-.062.187-.164.164-.257h0a1.4,1.4,0,0,0,0-.179c0-.07,0,.056.07,0-.07-.187,0-.312-.133-.428a.3.3,0,0,0-.133-.25,2.213,2.213,0,0,1-.281-.169v.039c-.056,0-.047,0-.062-.047s0,0,0,.056a2.8,2.8,0,0,1-.731-.21c-.085,0-.085.164-.187.062l.047-.056c-.2.039-.374-.07-.569-.039h-.154c-.008,0,0,0,0-.056s-.1.039-.117,0h-.1a.421.421,0,0,1-.179-.039c-.047-.039-.117-.047-.141,0,0-.085-.1-.093-.156-.056s0-.039,0-.07-.093,0-.093.047c-.07-.117-.2.056-.225-.085a2.634,2.634,0,0,1-.421,0c0-.085.148,0,.156-.07-.133,0-.21.07-.337,0s0-.039,0-.047c-.125,0-.234-.047-.351,0h-.056c0,.062-.1.109-.109.133.056-.1-.1-.039,0-.179a.062.062,0,0,0-.039.056V22.39c-.078,0-.056.056-.125.039s0,0,0-.039-.086.062-.141.039h0c-.1,0-.187.07-.3,0,.047-.078,0,0,0-.1h-.069v.039c-.056,0-.109.039-.148,0h.25c-.056,0,0,.093-.07.062s-.056,0-.078-.056-.056.039-.093,0,0-.078,0-.093-.125,0-.169.062a.125.125,0,0,0,0-.062v-.011c0-.062,0,.1-.07.047h-.251c-.078,0,.078,0,.056-.07s-.25.047-.359,0h0c0,.1-.07-.062-.133,0s0-.056,0-.047a2.449,2.449,0,0,1-.281,0h0a.647.647,0,0,0-.164-.047s-.047,0,0,.056c-.133-.169-.3.039-.413-.109h-.117v.062a.125.125,0,0,1-.085.039c.056,0,0-.07,0-.1v.047c0,.047,0,.085-.1,0h0s-.056.047-.085.047,0,0,0-.07-.07.117-.133.086.047,0,.062-.056a.1.1,0,0,0-.109,0H39.5c0,.148-.109.1-.1.225,0-.117,0-.047-.07-.085s-.062,0-.07,0a.112.112,0,0,0-.056.141c.031.093,0,.047-.062,0s0,0,.056,0S39.2,22.892,39.289,23.04Zm.148.288a.062.062,0,0,1,.056,0v.047ZM42.725,24.171Zm.07,0h0v.039Zm-2.423-1.737v.047h0s-.024-.031,0-.039Zm-.95.53v.047h-.056Z",
    transform: "translate(-13.871 -9.233)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137609",
    "data-name": "Path 137609",
    d: "M41.86,24.65Z",
    transform: "translate(-14.478 -9.791)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137610",
    "data-name": "Path 137610",
    d: "M39.73,24Z",
    transform: "translate(-14.008 -9.647)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137611",
    "data-name": "Path 137611",
    d: "M39.77,23.93v.039h.047Z",
    transform: "translate(-14.017 -9.632)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137612",
    "data-name": "Path 137612",
    d: "M46.088,25.187V25.17l-.008.016Z",
    transform: "translate(-15.41 -9.906)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137613",
    "data-name": "Path 137613",
    d: "M39.58,22.62Z",
    transform: "translate(-13.975 -9.343)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137614",
    "data-name": "Path 137614",
    d: "M44.31,22.842Z",
    transform: "translate(-15.02 -9.393)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137615",
    "data-name": "Path 137615",
    d: "M42.91,22.8h.039S42.918,22.765,42.91,22.8Z",
    transform: "translate(-14.71 -9.379)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137616",
    "data-name": "Path 137616",
    d: "M45.86,23.02Z",
    transform: "translate(-15.362 -9.431)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137617",
    "data-name": "Path 137617",
    d: "M39.676,24.058l.008-.008H39.66Z",
    transform: "translate(-13.993 -9.658)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137618",
    "data-name": "Path 137618",
    d: "M39.337,23.615h0v-.109A.157.157,0,0,0,39.337,23.615Z",
    transform: "translate(-13.92 -9.538)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137619",
    "data-name": "Path 137619",
    d: "M42.282,22.61l-.024.039.056-.008Z",
    transform: "translate(-14.566 -9.34)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137620",
    "data-name": "Path 137620",
    d: "M60.864,32.224c.07,0,.164.062.179,0s-.093-.047-.2-.047-.07-.07-.056-.085-.078-.062-.125,0a.553.553,0,0,0,.225.156S60.871,32.224,60.864,32.224Z",
    transform: "translate(-18.631 -11.427)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137621",
    "data-name": "Path 137621",
    d: "M61.26,33.212a.2.2,0,0,0,0-.062v.056Z",
    transform: "translate(-18.762 -11.668)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137622",
    "data-name": "Path 137622",
    d: "M55.28,31a.2.2,0,0,1,0,.056C55.3,31,55.444,31,55.28,31Z",
    transform: "translate(-17.442 -11.193)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137623",
    "data-name": "Path 137623",
    d: "M61.23,33.259V33.22h0Z",
    transform: "translate(-18.756 -11.683)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137624",
    "data-name": "Path 137624",
    d: "M44.328,31.527a.211.211,0,0,0-.078-.047h0Z",
    transform: "translate(-15.006 -11.299)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137625",
    "data-name": "Path 137625",
    d: "M10.872,3.276c0-.141-.056-.337-.1-.337a.388.388,0,0,1,0,.078c0-.039,0-.039.034,0s0,.164,0,.164a.466.466,0,0,0,0-.07c-.047.085.034.288,0,.444l-.028-.078a.9.9,0,0,0-.018-.5A.385.385,0,0,0,10.51,2.7h0a.725.725,0,0,0,0-.093h.028l.037-.056H10.51c0-.039,0-.078-.08-.125h-.093l-.028-.047h.08c-.042-.056-.07,0-.1,0a.073.073,0,0,0-.037-.056l-.093.062c0-.039.047-.062,0-.093s.034.086-.037.093,0-.078-.08-.056,0-.039.028-.047a.826.826,0,0,0-.145,0c-.028,0-.154,0-.145-.109a.193.193,0,0,1-.126.039c.084-.078-.154-.039-.126-.148-.061.078-.206,0-.309,0h.028a.394.394,0,0,1-.1-.078c0,.07-.1.07-.154.1-.061-.085.047-.078.034-.148,0,.056-.121,0-.1.085s-.047,0-.065-.1c0,.085-.051,0-.1.047s0-.093-.1-.085.037-.056.037-.056c-.084,0-.047.062-.065.1-.1,0-.042-.07-.075-.109s-.117.056-.169.039h0c-.075.039-.2-.047-.285,0h0a.255.255,0,0,1,0,.1H8.018a.023.023,0,0,0,.037,0H8.013c-.028-.078.056,0,.061-.062a.588.588,0,0,1-.234,0c0-.07.145,0,.07-.062L8,1.88c-.061-.125.056,0,0-.109s-.14,0-.257-.047c-.034,0,0,.056-.028.085-.178,0-.121-.2-.253-.141-.037,0-.056.109-.145.047l.037-.07c-.117,0-.075.093-.2,0H7.115V1.583H6.7s.037,0,0-.062a1.558,1.558,0,0,1-.538-.179L6.1,1.38s-.028,0,0-.039c-.065-.039,0,0-.042.047s-.047-.047,0-.056a.681.681,0,0,1-.468-.07H5.572c-.093-.047-.121.085-.2,0h0a2.12,2.12,0,0,1-.58-.218c-.037.078-.2-.086-.224,0A.843.843,0,0,0,4.326.875c-.047,0-.075.056-.131.047V.865L4.116.9,4.082.826H4.031s.037.039.034.056A.226.226,0,0,1,3.873.765H3.765c-.108,0,0-.07-.112-.039V.773A.39.39,0,0,0,3.429.695V.656C3.288.617,3.129.6,2.961.563c.056.039.037.1,0,.1V.594c-.034,0,.047.039,0,.07s-.037-.085,0-.093H2.886V.524c0-.047-.117-.093-.169-.039h0a.61.61,0,0,1-.36-.07c0,.056-.056,0-.1.07A1.487,1.487,0,0,0,1.947.345c-.08,0-.023.047-.065.07S1.751.267,1.831.267a1.581,1.581,0,0,0-.356,0s.037.039.028.047A.052.052,0,0,1,1.437.257h0C1.235.257,1,0,.839.07H.675C.6.07.722.07.675,0a.457.457,0,0,0-.5.257A.646.646,0,0,0,0,.779a1.852,1.852,0,0,0,.14.647V1.387c.051.039.037.086.07.141s-.037-.085,0-.07a.523.523,0,0,0,.3.164l.253.085.5.2c.121.039.084-.156.234,0l-.051.056c.253,0,.506.125.753.125H2.158c-.042,0,.187.047.192,0s0,0,.028.062.131,0,.154,0h0s.154.047.126,0c.089.047.178,0,.248.07s.15.062.173,0c0,.085.154.109.215.085,0,0,.047.039,0,.07.065,0,.131,0,.121-.039.112.141.248,0,.3.133h.561c0,.078-.2-.047-.2.047a1.163,1.163,0,0,1,.435,0H4.473c.173,0,.323.085.468.078h0c-.042-.07.126-.093.135-.117-.061.1.14.062.051.187a.041.041,0,0,0,.042-.047c0-.047.037,0,0,.056.108,0,.07-.047.169,0-.017,0-.031.021-.037.047a.182.182,0,0,1,.183,0h0a.97.97,0,0,1,.393,0c-.051.07.047.039.047.109h.327l-.07-.047c.075,0,0-.093.093-.047a.127.127,0,0,1,.1.07h0a.121.121,0,0,1,.126,0v.1a.962.962,0,0,0,.215,0,.113.113,0,0,0,0,.062l.037-.047c.028,0,.034,0,.023.062.1,0-.023-.093.093,0H6.847a1.232,1.232,0,0,1,.337.078c0,.078-.1,0-.065.062a2.371,2.371,0,0,1,.468.047h0c.028-.093.108.078.187.056h0a1.262,1.262,0,0,0,.371,0h0a1.062,1.062,0,0,0,.224.078s.056,0,.037-.047c.187.2.393,0,.561.187h.117c0-.047,0,0-.047-.07a.122.122,0,0,1,.108,0c-.07,0,0,.07,0,.1V3.432c.07.1,0-.085.126,0h0a.345.345,0,0,1,.126,0c0,.056-.047,0-.052.056s.131-.062.183,0H9.436a.165.165,0,0,0,.108.078h0l.1.056H9.622c.089-.117.159,0,.27-.047-.112.056,0,.047-.037.1s.065.047.051.062c.056,0,.08.056.154,0s.056,0,.037.056c.065,0,0,0,0-.056.108,0,.224.141.379.078a.419.419,0,0,0,.248-.225h0c.037,0,0,.085,0,.085a.328.328,0,0,0,.131-.218h.037c.037,0,0-.078,0-.179a.251.251,0,0,1,.028.109,1.131,1.131,0,0,0,0-.337A.988.988,0,0,0,10.872,3.276ZM6.662,1.577Zm-.093,0a.054.054,0,0,1-.007.028.02.02,0,0,1-.017.011c-.023,0-.028,0-.052-.056ZM8.651,3.47a.074.074,0,0,1,0-.047H8.7a.067.067,0,0,1-.051.024Zm1.656.366h.019Zm.407-.225a.641.641,0,0,0,.037-.109,1.3,1.3,0,0,1,0,.133l-.034-.047Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 24.791, 18.219)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137626",
    "data-name": "Path 137626",
    d: "M47.07,29.75v.016l.024-.008Z",
    transform: "translate(-15.629 -10.917)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137627",
    "data-name": "Path 137627",
    d: "M59,33.56Z",
    transform: "translate(-18.263 -11.759)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137628",
    "data-name": "Path 137628",
    d: "M48.58,32.09Z",
    transform: "translate(-15.962 -11.434)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137629",
    "data-name": "Path 137629",
    d: "M51.665,32.39H51.58C51.627,32.414,51.658,32.421,51.665,32.39Z",
    transform: "translate(-16.625 -11.5)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137630",
    "data-name": "Path 137630",
    d: "M45.116,31.658h0L45.1,31.65Z",
    transform: "translate(-15.194 -11.336)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137631",
    "data-name": "Path 137631",
    d: "M61.288,32.45H61.28l.016.031Z",
    transform: "translate(-18.767 -11.513)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137632",
    "data-name": "Path 137632",
    d: "M60.76,33.659a.366.366,0,0,0,.218-.109h0C60.947,33.6,60.8,33.612,60.76,33.659Z",
    transform: "translate(-18.652 -11.756)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137633",
    "data-name": "Path 137633",
    d: "M53.02,32.65l.062.039.039-.039Z",
    transform: "translate(-16.943 -11.557)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137634",
    "data-name": "Path 137634",
    d: "M59.754,39.152c.07,0,.164.056.179,0s-.086-.056-.2-.047-.07-.078-.056-.093-.078-.056-.125,0a.436.436,0,0,0,.225.156S59.761,39.144,59.754,39.152Z",
    transform: "translate(-18.386 -12.955)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137635",
    "data-name": "Path 137635",
    d: "M60.16,40.132a.2.2,0,0,0,0-.062v.056Z",
    transform: "translate(-18.52 -13.196)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137636",
    "data-name": "Path 137636",
    d: "M54.2,37.93a.117.117,0,0,1,0,.056S54.364,37.985,54.2,37.93Z",
    transform: "translate(-17.203 -12.724)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137637",
    "data-name": "Path 137637",
    d: "M60.13,40.18Z",
    transform: "translate(-18.513 -13.22)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137638",
    "data-name": "Path 137638",
    d: "M43.328,38.464a.163.163,0,0,0-.078-.047h0Z",
    transform: "translate(-14.785 -12.83)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137639",
    "data-name": "Path 137639",
    d: "M55.117,38.842c0-.141-.093-.337-.164-.337a.234.234,0,0,1,0,.078h.056c.056,0,0,.156,0,.164v-.068c-.085.086.047.288,0,.444a.467.467,0,0,0-.062-.1.265.265,0,0,0,.039-.109.585.585,0,0,0-.491-.67h0a.412.412,0,0,0,0-.093.047.047,0,0,0,.047,0L54.6,38.1h-.1c0-.039-.039-.085-.133-.133h-.164v-.056h.125c-.062-.056-.117,0-.169,0a.093.093,0,0,0-.056-.056l-.156.062s.07-.056,0-.093.056.093-.062.1,0-.085-.133-.062,0,0,.047,0h-.242c-.047,0-.257,0-.234-.109a.506.506,0,0,1-.21,0c.141-.085-.257-.047-.21-.148-.109.078-.343,0-.514,0a.056.056,0,0,1,.047,0,.725.725,0,0,1-.169-.078c0,.07-.169.07-.257.1-.1-.093.085-.078.062-.156,0,.062-.21,0-.179.093-.078-.062-.07-.039-.109-.109,0,.093-.078,0-.164.056s0-.093-.156-.086.062-.056.062-.056c-.141,0-.078.062-.109.1-.169,0-.07-.07-.125-.109s-.2.056-.273.039h0a1.565,1.565,0,0,0-.468,0h0a.156.156,0,0,1,0,.1h-.148c-.047-.078.093,0,.1-.062a1.62,1.62,0,0,1-.39,0c0-.07.234,0,.117-.062l.039.078c-.1-.125.085,0,0-.109s-.234,0-.428-.047c-.047,0,0,.056-.047.085-.288,0-.2-.2-.421-.141-.062,0-.093.117-.234.047l.062-.062c-.2-.039-.125.085-.327,0h-.07v-.066h-.684s.056,0,0-.062a3.748,3.748,0,0,1-.888-.179h-.117c-.1-.039,0,0-.062.047s-.078,0,0-.056a1.675,1.675,0,0,1-.779-.07h.047c-.156-.047-.2.093-.337,0h0a4.552,4.552,0,0,1-.974-.2c-.062.07-.337-.085-.374,0a1.48,1.48,0,0,0-.4-.179c-.07,0-.117.056-.21.056v-.07L43.9,36.5l-.056-.078H43.8s.062.039.056.056a.429.429,0,0,1-.312-.125h-.179c-.171,0,0-.07-.179,0V36.4a.99.99,0,0,0-.374-.078v-.039a6.548,6.548,0,0,1-.779-.093c.093,0,.062.1,0,.1v-.07c-.056,0,.078,0,0,.07s-.056-.085,0-.093h-.125v-.047c0-.047-.2-.093-.281,0h0a1.8,1.8,0,0,1-.6-.062c0,.056-.093,0-.164.062a3.785,3.785,0,0,0-.514-.133c-.133,0-.047,0-.109.062s-.225-.169-.1-.169a3.179,3.179,0,0,0-.585-.039s.062.039.039.056-.117,0-.1-.062h0c-.337,0-.725-.257-1-.2h-.273c-.117,0,.078,0,0-.07a.956.956,0,0,0-.826.257.545.545,0,0,0-.281.522,1.216,1.216,0,0,0,.242.647h0c.085,0,.07.085.125.141s-.062-.085,0-.07a1.068,1.068,0,0,0,.491.164l.421.085.826.2c.2.039.141-.164.382,0l-.078.047c.421,0,.834.133,1.237.125H40.7a.382.382,0,0,0,.319,0c.062,0,0,0,0,.056s.225,0,.265,0h-.047c-.047,0,.257.047.21,0,.148.047.3,0,.405.07s.257.07.3,0c0,.085.25.109.351.085,0,0,.078.039.039.07h.2c.187.133.413,0,.506.125h.92c0,.086-.319,0-.319.056a3.647,3.647,0,0,1,.717,0c.07,0-.047,0-.07.047.281,0,.53.085.779.078h.008c-.07-.07.21-.093.225-.125-.1.1.234.07.085.2,0,0,.07,0,.07-.047s.056,0,0,.056c.169,0,.117-.047.273,0a.061.061,0,0,0-.056.047.421.421,0,0,1,.3,0h0a3.584,3.584,0,0,1,.639,0c-.085.078.085.047.085.117h.141l-.056-.047h.46l-.125-.047c.125,0,0-.093.156-.056a.243.243,0,0,1,.169.07h0a.319.319,0,0,1,.21,0v.1a1.778,1.778,0,0,0,.359,0c.085,0,0,.047,0,.056h.056c.056,0,.062,0,.047.062.164,0-.039-.1.148,0h0c.187.056.382,0,.553.078.039.086-.156,0-.109.062a3.6,3.6,0,0,1,.779.056h-.04c.056-.1.179.078.311.047,0,0-.047.047-.039,0a2.875,2.875,0,0,0,.618,0h0a1.761,1.761,0,0,1,.366.086c.109.031.1,0,.062-.056.319.2.654,0,.935.187h.2c0-.047,0,0-.078-.07a.3.3,0,0,1,.169,0c-.117,0,0,.07,0,.1v-.049c.125.093.039-.085.21,0h0a.952.952,0,0,1,.21,0c0,.056-.078,0-.085.056s.218-.07.3,0h-.212a.312.312,0,0,0,.179.078h0l.169.056h0c.141-.117.257,0,.444-.047-.179.056,0,.039-.056.1s.109.047.085.062.133.056.257,0c0,0,.085,0,.062.056.109,0,0,0,0-.056.171-.047.366.133.623.078a.6.6,0,0,0,.4-.234h0c.056,0,0,.093,0,.093a.337.337,0,0,0,.218-.218h.062c.062,0,0-.078,0-.187a.281.281,0,0,1,.047.117.779.779,0,0,0,0-.337.371.371,0,0,0,.021.1ZM48.151,37.152Zm-.164,0h0A.115.115,0,0,1,47.9,37.1Zm3.459,1.87a.047.047,0,0,1,0-.047h.085A.112.112,0,0,1,51.447,39.022Zm2.743.366H54.3a.148.148,0,0,1-.078,0Zm.67-.234a.849.849,0,0,0,.085-.133.847.847,0,0,1,0,.141.043.043,0,1,1-.085-.008Z",
    transform: "translate(-13.43 -12.202)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137640",
    "data-name": "Path 137640",
    d: "M46.05,36.688v.006l.024-.008Z",
    transform: "translate(-15.403 -12.448)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137641",
    "data-name": "Path 137641",
    d: "M57.87,40.48Z",
    transform: "translate(-18.014 -13.287)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137642",
    "data-name": "Path 137642",
    d: "M47.56,39Z",
    transform: "translate(-15.737 -12.96)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137643",
    "data-name": "Path 137643",
    d: "M50.628,39.32H50.55C50.589,39.344,50.62,39.351,50.628,39.32Z",
    transform: "translate(-16.397 -13.031)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137644",
    "data-name": "Path 137644",
    d: "M44.138,38.6Z",
    transform: "translate(-14.988 -12.872)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137645",
    "data-name": "Path 137645",
    d: "M60.17,39.37l.016.031-.008-.031Z",
    transform: "translate(-18.522 -13.041)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137646",
    "data-name": "Path 137646",
    d: "M59.66,40.579a.436.436,0,0,0,.225-.109h0C59.87,40.509,59.7,40.532,59.66,40.579Z",
    transform: "translate(-18.409 -13.284)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137647",
    "data-name": "Path 137647",
    d: "M52.032,39.629l.039-.039h-.1Z",
    transform: "translate(-16.711 -13.09)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137648",
    "data-name": "Path 137648",
    d: "M26.928,33.87c-.056,0-.039-.062-.078-.117a1.8,1.8,0,0,0,.056-.382c0-.093-.047,0-.078-.07s.039-.148.078-.078a1.676,1.676,0,0,0-.078-.428v-.039h0c-.1-.225.047-.585-.117-.779h0c0-.062-.07-.117-.109-.179s.047.039.056,0c-.148-.179-.117-.327-.25-.468.062-.2-.265-.421-.3-.618h0c-.056,0,0-.062-.039-.093s0,.056,0,.047c-.281-.3-.506-.67-.779-.966-.109-.109-.179.078-.273-.1H25.1c-.281-.133-.491-.382-.779-.491h.056c.056,0-.2-.125-.218-.093s0,0,0-.07-.169,0-.179-.078,0,0,.039,0-.169-.093-.156,0c-.093-.07-.2-.078-.273-.141s-.164-.109-.21-.039c.039-.078-.156-.141-.234-.125s-.056-.047,0-.078-.148,0-.148,0c-.109-.148-.312,0-.359-.164a3.96,3.96,0,0,1-.694-.039c0-.085.242,0,.25-.062a2.5,2.5,0,0,1-.53,0c-.056,0,0-.039.047-.047a1.934,1.934,0,0,0-.562,0h-.039c.047.062-.148.109-.164.141.07-.109-.169-.047-.062-.179,0,0-.056,0-.056.047s-.047,0,0-.056c-.125,0-.085.062-.2.056l.039-.047a.281.281,0,0,1-.218.056h0c-.169,0-.281.117-.476.109.039-.093-.062,0-.093-.078l-.093.039h.047c-.085,0-.141.085-.218.093l.047-.056-.148.07h.093c-.07.062,0,.085-.07.1H19.4a.187.187,0,0,1-.125.085v-.093c0-.016-.179.1-.2.187s0-.062,0-.062v.056h-.062c-.008,0,.078.07-.07.093h0c-.141.056-.234.156-.359.21s.093-.078,0-.109c-.164.117-.288.3-.436.405h0c.047.085-.141.047-.169.148v-.047a1.052,1.052,0,0,0-.265.374h0c-.07.039-.133.148-.187.21s0,.07,0,.07c-.265.133-.164.444-.366.585v-.047l-.056.179h.085a.2.2,0,0,1,0,.133c0-.093-.07,0-.109,0a.07.07,0,0,1,.039,0c-.109.062.078.047,0,.148h0v.148c0,.047,0-.056-.039-.07s.047.169,0,.218a.592.592,0,0,0,0-.117.179.179,0,0,0-.164-.031h0l-.062.109h0c.1.133,0,.187,0,.337-.047-.141,0,0-.093-.062s-.056.07-.07.056-.062.085,0,.187,0,.07-.062.047.039,0,.062,0-.133.273-.047.468a1.608,1.608,0,0,0,.164.288h0c0,.039-.07,0-.07,0a.242.242,0,0,0,.078.2l-.039.047c-.039.047.078,0,.109.078a.225.225,0,0,1-.1,0,1.028,1.028,0,0,0,.2.125c0,.039-.07,0-.1,0a.475.475,0,0,0,.164.085.07.07,0,0,1-.056-.093h.047c0-.117-.156-.133-.2-.234h.085a.9.9,0,0,0,.592.405h0a.21.21,0,0,0,0,.093.047.047,0,0,0-.039,0l-.039.062h.07a.148.148,0,0,0,.093.125l.109-.039v.056h-.093c.047.047.085,0,.125,0s0,.047.039.056l.117-.07c0,.039-.056.062,0,.093s0-.085.056-.1,0,.085.085.056,0,0,0,.047.141,0,.169,0,.187,0,.164.1a.25.25,0,0,1,.156-.047c-.109.085.179,0,.141.141.085-.086.25,0,.374,0h0l.117.07c.039.024.125-.07.187-.109.07.085-.062.078-.047.148,0-.056.148,0,.133-.093s.047,0,.07.1c0-.093.056,0,.117-.056s0,.093.109.078-.047.056-.047.056.056-.062.085-.1.047.062.078.109.148-.062.2-.056h.337a.21.21,0,0,1,0-.1h.1c0,.07-.07,0-.078.062s.21-.047.281,0-.169,0-.085.07l-.1-.047c.062.117-.07,0,0,.109s.164,0,.3,0,0-.056,0-.085c.218,0,.133.187.3.125s.078-.117.179-.056l-.056.07c.141,0,.1-.093.234,0h.056v.07h.483s-.047,0,0,.062a1.87,1.87,0,0,1,.623.148H22.7l.056-.047c.056-.047.056.039,0,.056a.974.974,0,0,1,.538.039h0c.109.039.148-.093.242,0h0a2.673,2.673,0,0,1,.686.169c.056-.078.234.078.273,0a.966.966,0,0,0,.273.156c.056,0,.093-.056.156-.056v.056l.1-.047v.078h.062a.038.038,0,0,1-.039-.047.25.25,0,0,1,.225.109h.148c.133-.039,0,.07.133,0v-.047a.46.46,0,0,0,.265.07h0a1.317,1.317,0,0,0,.686,0c-.117,0-.1-.062,0-.093h.056c.039-.056-.085,0,0-.07s.1,0,.056.07a.67.67,0,0,0,.1-.109v.062c0,.062.218-.2.164-.288h0a1.742,1.742,0,0,0,.056-.522Zm-9.537-3.584V30.27ZM16.814,32.015Zm0,.141v.085a.109.109,0,0,1-.047-.056Zm0,.562a.051.051,0,0,1,.1-.016.234.234,0,0,0,.047.085ZM22,34.043Zm.109,0h0c0,.039,0,0,.056.047Z",
    transform: "translate(-8.904 -10.556)",
    fill: "#fc6d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137649",
    "data-name": "Path 137649",
    d: "M22.665,19.892s.056,0,.047.047h.066c-.125.056,0,.179-.093.234l.039.148h0s.109,0,.085.085-.039,0-.062,0,0,.078,0,.133h0c0,.047.07.07.078.125h0a.257.257,0,0,1,.148.117h-.082c-.078,0,.078-.039.1,0a.2.2,0,0,1-.078.085h0c-.056.047,0,.056,0,.078h0c0,.062.1,0,.125.1h0c.085,0,0,.047.047.062l-.07.039a.678.678,0,0,1,.141.085A.311.311,0,0,1,23,21.175s.039.078.078.078h0a.133.133,0,0,1,.133.07c-.141.062,0,.133-.056.218.093.056.07.179.141.265.07-.093,0,0,.117-.047h0v.1c0,.039-.039,0-.056,0s0,.047,0,.093.062,0,.07,0v-.07c.093,0-.039.117.056.141h-.175c.039,0,.1.117.2.078s0,.047-.039.039.218.078.234.179h.093c.047.093.164.039.234.062a.148.148,0,0,0,0,.169h0c.093.07.2.047.312.056s.179.125.265.21,0-.062.047-.07.078-.039.056,0h0c0,.085.062.078.1.085v-.1c.085.169.273,0,.327.109a.1.1,0,0,0,.085-.056v.056a.405.405,0,0,0,.21,0v.039c.062,0,0-.169.07-.179v.07c.078,0,.21,0,.242-.109a.047.047,0,0,1,0,.047s.164,0,.093-.125c.039.062.078,0,.093-.093V22.4c0-.047.039,0,0,0s0-.062.047-.07v.039c.039,0,0-.039,0-.086s.062-.047.1,0,0-.07,0-.078h0s0-.117.1-.117h0l-.07.078a.117.117,0,0,1,.1.073v-.179h.039c.039,0,.047,0,.062-.056s0-.047-.078-.047h0v-.016l.109.133h.2c.047,0,.056-.164,0-.242s0,0,.056,0,0,0,0,.039,0-.117-.039-.148.056.047.062,0h0c.148-.117-.133-.242,0-.366h0c.086-.169-.07-.337,0-.514,0-.047,0-.047-.078-.062H26.5c-.062-.047.109-.156,0-.21h-.039s-.056-.085,0-.1-.047,0,0,0h0l-.078-.047c0-.062.109-.039.078-.125a.171.171,0,0,0-.133,0v.056h0a1.714,1.714,0,0,0-.133-.2h0l-.164-.2h0s-.039,0,0-.056H26s.047-.039.047,0-.1,0-.07-.085-.062,0-.1,0h0l.062-.093h-.1c-.056,0-.093-.047-.039-.125s0,.047-.047.047c.062-.085-.047,0,0-.078s.047,0,.056-.047-.047-.062-.078-.062a.047.047,0,0,1-.039,0h.039s-.039,0-.056.056-.047-.039-.085-.047-.056-.085-.085-.133h0c-.047.056-.078,0-.117,0a.1.1,0,0,1,.062-.056h0a.093.093,0,0,1-.062,0h.037a.18.18,0,0,1-.148-.047.778.778,0,0,1-.056.117h-.008c-.047,0,0,0,0-.062h0a.14.14,0,0,1,0-.078v-.031c0-.024-.039,0-.062.039s0,0,0-.056-.109,0-.1.039h0c-.085,0-.141-.078-.218-.078h-.141c-.039,0,0-.039,0-.062s-.039,0-.085,0h.039c.039,0-.047-.056-.1,0s0-.062-.047-.056v.039a.086.086,0,0,1-.062,0v-.062c-.085-.093-.169.125-.242,0,0,0,.056,0,0,.085s-.093-.1-.1-.1-.056.1-.117.078,0,.078,0,.109-.062-.085,0-.109h0v-.047h0s-.085,0-.078-.047,0,0,0,.047-.085,0-.148,0h0l-.047-.039s0-.085-.062-.047,0-.056,0-.078-.1,0-.141,0h0a.07.07,0,0,1-.047,0l.039.039h-.039c-.039,0,.039.07,0,.117s-.047.056-.078,0,0-.047,0-.085,0,0-.047,0h0c-.085,0,0,.078-.056.109s-.047-.047-.056,0,.047,0,.039.078,0,.039-.056.047h0v.031c0-.039-.1,0-.109.056s-.047-.047-.07-.047a.094.094,0,0,0-.1.078c-.024.078.039,0,.047.07A.3.3,0,0,1,23,19.232v.085s0-.062.039-.062,0,0,0,.056,0,.078-.085.078l-.047-.117c-.085,0-.039.133-.109.2h0v.086a.1.1,0,0,0-.078,0v.1h-.059c-.047.07.078.117.047.169s-.07,0-.085-.056,0,0,0,.047S22.713,19.874,22.665,19.892ZM26.436,22.175ZM26,19.837h0s.031.024.031.031Z",
    transform: "translate(-10.229 -8.5)",
    fill: "#fc6d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137650",
    "data-name": "Path 137650",
    d: "M72.732,18.817c-.056.327-.109.686-.164,1.059-.047.148,0,0,0-.039-.07.5-.133,1.083,0,.779,0-.506.086-.618.117-1.161.062-.421.141-.731.156-.662a4.387,4.387,0,0,0,.078-.9C72.889,18.17,72.786,18.482,72.732,18.817Z",
    transform: "translate(-21.242 -8.298)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137651",
    "data-name": "Path 137651",
    d: "M71,19.47a3.433,3.433,0,0,0,0,.413Z",
    transform: "translate(-20.91 -8.647)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137652",
    "data-name": "Path 137652",
    d: "M61.17,12.2Z",
    transform: "translate(-18.743 -7.042)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137653",
    "data-name": "Path 137653",
    d: "M71.05,19.079l.047-.359Z",
    transform: "translate(-20.924 -8.481)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137654",
    "data-name": "Path 137654",
    d: "M32.09,7.89a2.633,2.633,0,0,1,.337.1C32.316,7.975,33.415,8.085,32.09,7.89Z",
    transform: "translate(-12.321 -6.09)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137655",
    "data-name": "Path 137655",
    d: "M70.994,19.407a.779.779,0,0,1,0-.225Z",
    transform: "translate(-20.909 -8.584)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137656",
    "data-name": "Path 137656",
    d: "M40.1,49.25l1.184.187Z",
    transform: "translate(-14.09 -15.223)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137657",
    "data-name": "Path 137657",
    d: "M46.13,50.15c.21.056.428.093.662.141h.141Z",
    transform: "translate(-15.422 -15.422)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137658",
    "data-name": "Path 137658",
    d: "M71.237,27.823l-.047-.056Z",
    transform: "translate(-20.955 -10.478)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137659",
    "data-name": "Path 137659",
    d: "M56.673,19.081a.538.538,0,0,0,.468.351.545.545,0,0,1-.421-.421.446.446,0,0,1,0-.1.452.452,0,0,0,.9.117c.179-.779.319-1.5.45-2.252l.187-1.13a3.218,3.218,0,0,0-.085-1.387l-.056-.117c.056.039.117.125.148.133s0,.164.07.327a1.931,1.931,0,0,1,.1.3,3.272,3.272,0,0,0-.141-.678h0a2.181,2.181,0,0,0-.476-1.169,3.584,3.584,0,0,0-1.012-.834L56.451,12a3.53,3.53,0,0,1,.912.592,2.626,2.626,0,0,0-1.249-.706,2.244,2.244,0,0,0-.514-.169l-1.2-.093c-.133-.056.545,0-.25-.125-.553-.047.522.156-.4.047a4.48,4.48,0,0,0-1.059-.179c-.093-.039.056,0,.319,0-.6-.062-1.559-.225-1.911-.225-.592-.141-2.023-.288-1.956-.366-.2,0-1.068-.093-1.62-.169,1.021.047-2.065-.312-1.785-.382-.779,0-2.7-.359-4.028-.506a1.846,1.846,0,0,1,.337,0c-.779-.117-.95-.179-1.426-.265a18.7,18.7,0,0,1-1.9-.148c-.9-.2.569,0,.3-.117,0,.07-1.6-.169-1.293-.078a6.062,6.062,0,0,1-.95-.225,6.958,6.958,0,0,1-1.237-.109,8.361,8.361,0,0,0-1.325-.257c-.522-.109.468,0,.468,0-1.13-.169-.538,0-.779,0-1.349-.179-.618-.141-1.068-.25-.843-.109-1.5-.141-2.127-.234-.047,0-.164-.039,0,0-.9-.078-2.642-.4-3.685-.476l-.2-.085c.164.062.187.1.148.117a8.851,8.851,0,0,1-1.13-.117,2.805,2.805,0,0,0,.483,0l-.53-.062c-.468-.141.724.085.731.039-1.036-.133-2.252-.257-3.039-.4-.156-.093,1.855.257.779,0l1.223.21c-.92-.25.779.117-.1-.125L22,6.7c-.366,0,.109.07-.257.056-2.3-.281-1.777-.436-3.467-.6a8.571,8.571,0,0,1-1.815-.187h.42c-1.559-.242-.9,0-2.548-.312.3,0,1.237.148,1,.109a4.192,4.192,0,0,0-.881-.125,5.837,5.837,0,0,0-.731,0l-.19-.059A3.381,3.381,0,0,0,11.2,6.985a3.117,3.117,0,0,0-.562,1.325c-.109.468-.141.927-.218,1.387,0-.1,0-.421-.062,0-.312,2.338-.779,4.956-1.124,7.194l-.07.865c0,.2-.078.359-.056.148-.156.865,0,.047,0,.468s-.133.654-.1.337c-.179,1.559-.553,4.4-.857,6.023v-.319c-.2,1.244-.091,1.433-.316,2.593v-.225C7.622,28.16,7.4,29.6,7.2,30.965l-.265,1.956a10.425,10.425,0,0,0-.218,1.815A4.317,4.317,0,0,0,7.256,36.3a2.408,2.408,0,0,0,1.037,1,2.711,2.711,0,0,0,.779.421,5.2,5.2,0,0,0,.562.169c.359.078.779.156,1.9.343.585.093.888.056,1.613.156v.062l1,.085.585.1.686.085a1.879,1.879,0,0,1-.53-.125c.538.07,1.184.169,1.7.273a8.571,8.571,0,0,1,.92.2l2.532.327a3.6,3.6,0,0,1-.576-.047c.965.109.077.078,1.23.195h.125c.618.125,2.011.337,3.054.476h-.2l6.047.888c-.779-.133-.562-.179.056-.093l.234.1c.405,0-.639-.117.187-.047s.514.148.062.1l.958.125h-.234c.4,0,1.636.312,2.213.327h.056l4.769.686a9.352,9.352,0,0,1,1.223.093c1.255.2,2.642.46,4.159.678,1.068.133.319,0,.779.039.07.062,1.559.281.779.2,1.823.265,2.338.337,4.629.639-.242-.056-.522-.109-.374-.1a3.9,3.9,0,0,1,.881.179h-.109L51,43.95a3.335,3.335,0,0,0,1.13-.093,3.459,3.459,0,0,0,1.9-1.226,4.013,4.013,0,0,0,.779-2.034c.1-.647.187-1.247.234-1.761v.117l.2-2.143c.156-.982-.056.592.085-.125.265-2.338.553-3.631.779-5.54.187-.717.374-2.018.569-3.389.1-.678.2-1.379.3-2.034s.218-1.255.242-1.792v-.467a.779.779,0,0,0-.187-.538.843.843,0,0,1,.156.312.337.337,0,0,1,0,.117,1.2,1.2,0,0,1,0-.141.654.654,0,0,0-1.044-.288,1.114,1.114,0,0,0-.257.444,3.677,3.677,0,0,0-.141.413,14.6,14.6,0,0,0-.3,1.676c-.2,1.114-.413,2.267-.585,3.358-.359,2.244-.724,4.5-1.075,6.725-.25,1.62,0,.943-.351,2.984v-.595c-.109.826-.225,1.652-.337,2.485a2.79,2.79,0,0,1-.311,1.107,1.831,1.831,0,0,1-1.948.779L49.6,42.124l-2.447-.343a4.448,4.448,0,0,1,.522.047c-.337-.078-.966-.169-1.511-.242l-.709-.085h-.3c-.5-.078-.117-.056-.421-.117-.67-.133-1.714-.2-2.065-.3h.164a10.331,10.331,0,0,0-1.473-.117c-1.2-.2-2.338-.319-3.265-.491-.639,0-2.057-.337-2.267-.281a18.7,18.7,0,0,0-2.875-.46c.265,0-.654-.125-.351-.117a6.319,6.319,0,0,0-1.5-.21c-1.559-.351-3.226-.4-4.114-.67l-7.307-.99c.1-.078,2.571.374,2.485.265-2.2-.288-3.491-.405-5.672-.779-.569-.093.327,0,.522,0-2.213-.3-4.262-.647-6.233-.9l.421.039a5,5,0,0,0-.857-.1l.374.047c.3.078-.078.056-.553,0a2.979,2.979,0,0,1-1.012-.242c.319.1-.125-.093-.4-.421s-.39-.654-.093-.281c-.148-.179-.257-.45-.265-.39-.093-.343-.085-.45,0-.117a2.423,2.423,0,0,1-.062-1.044,4.38,4.38,0,0,1,.122-1.019,2.291,2.291,0,0,1,0,.39c.062-.639.117-1.278.288-2.338v.265c.265-1.823.366-3.117.694-5.1,0,.6.133-.678.218-.779l.141-1.075-.1.421c.141-.935.218-1.777.359-2.579l-.07.7.25-1.761-.169,1.075c.1-.95-.109.093.1-1.153,0,.25.141-.943.257-1.426h0c.047-.468.093-.95.21-1.636.056-.179.062.156.093,0,0-.468.312-2.2.337-2.8,0,.2,0,.218.039.156v-.4c.085-.428.1-.491.117-.421.21-1.309-.148.405.117-1.145a2.2,2.2,0,0,1,0,.319c.225-1.559.444-3.008.654-4.449.141-.413-.169,1.255,0,.779a5.508,5.508,0,0,1,.109-.779l.047-.4.093-.359a1.94,1.94,0,0,1,.958-1.107,2.338,2.338,0,0,1,1.5-.124l1.559.225-.366-.07c.288-.056,1.48.281,2.5.382h-.265c1.364.218,2.805.39,4.885.67h-.257l2.891.506c.265,0,.779.093.46,0,2.673.553,5.142.686,7.511,1.169-.281-.047-.678-.078-.45-.047l2.034.281a3.95,3.95,0,0,0-.686-.164c.265,0,.843.078,1.34.148-.912-.1,0,.078.39.156h.047c1.044.234.187-.062,1.63.2h-.078c.545.07,1.052.109,1.636.2.234.085-.585-.062-.631,0,.826.117,1.636.148,2.338.3l-1.208-.148c.779.179.9.179,1.5.281h-.016l1.387.234-.351-.07c1.044,0,2.1.288,3.5.405-1.364-.117-.234,0-.343.062a3.766,3.766,0,0,1,.731.156c.654.056,1.083.2,2.018.273,0,0,.7.109.545.133.857.109-.2-.062-.125-.078,1.325.133,3.117.538,4.979.731.779.109,1.309.141,1.761.21a1.886,1.886,0,0,1,1,.538h0a1.825,1.825,0,0,1,.2.265,1.231,1.231,0,0,1,.156.281,1.406,1.406,0,0,1-.093-.133,2.578,2.578,0,0,0-.242-.312,2.2,2.2,0,0,1,.436,1,4.239,4.239,0,0,1-.047,1.075c0-.156,0,0-.085.234-.078.631,0,.428-.1,1.255a5.217,5.217,0,0,1,.016-.631c-.047.779-.125,1.457-.133,2.267,0,.125-.062,0-.047-.218s0-.405,0-.545a6.734,6.734,0,0,0,0,.779.585.585,0,0,0,.631.45.514.514,0,0,1-.374-.109.444.444,0,0,1-.21-.355ZM10.514,9.149l-.07.545h0C10.474,9.469,10.5,9.273,10.514,9.149Zm-.257,1.8c0-.078.039,0,0,.234a6.59,6.59,0,0,0-.148.724c.039-.264.093-.606.148-.957Zm20.4-1.488s-.047,0,0-.047l.779.109a3.35,3.35,0,0,1-.779-.062Zm22.293,3.335-.3-.093.888.133Zm4.075,2.86c0-.133.062-.242.078-.2h0l-.141.982c.024-.242.039-.506.062-.779Zm-.109.662v.359c-.093.709-.164,1.426-.21,2.143v-.653c.1-.618.1-1.3.21-1.846Z",
    transform: "translate(-6.718 -5.58)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137660",
    "data-name": "Path 137660",
    d: "M23.174,48.9Z",
    transform: "translate(-10.449 -15.146)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137661",
    "data-name": "Path 137661",
    d: "M53.09,51.19Z",
    transform: "translate(-16.958 -15.651)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137662",
    "data-name": "Path 137662",
    d: "M71.853,23.31l-.133.07Z",
    transform: "translate(-21.072 -9.495)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137663",
    "data-name": "Path 137663",
    d: "M71.975,23.2a.885.885,0,0,1-.085.085Z",
    transform: "translate(-21.11 -9.471)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137664",
    "data-name": "Path 137664",
    d: "M72.05,23.13v0Z",
    transform: "translate(-21.145 -9.456)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137665",
    "data-name": "Path 137665",
    d: "M71.562,23.43Z",
    transform: "translate(-21.039 -9.522)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137666",
    "data-name": "Path 137666",
    d: "M72.05,23.1a.5.5,0,0,0,.062-.109A.366.366,0,0,1,72.05,23.1Z",
    transform: "translate(-21.145 -9.425)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137667",
    "data-name": "Path 137667",
    d: "M72.225,22.17l-.125.538c.056-.3.085-.164,0,.093a.779.779,0,0,0,.062-.25,1.666,1.666,0,0,0,.062-.382Z",
    transform: "translate(-21.156 -9.243)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137668",
    "data-name": "Path 137668",
    d: "M72.13,23Z",
    transform: "translate(-21.163 -9.427)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137669",
    "data-name": "Path 137669",
    d: "M71.73,23.42Z",
    transform: "translate(-21.113 -9.52)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137670",
    "data-name": "Path 137670",
    d: "M14.985,47.7v-.014l-.2-.016Z",
    transform: "translate(-8.501 -14.875)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137671",
    "data-name": "Path 137671",
    d: "M44.61,11.71Z",
    transform: "translate(-15.086 -6.934)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137672",
    "data-name": "Path 137672",
    d: "M51.38,12.74l.74.133Z",
    transform: "translate(-16.581 -7.161)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137673",
    "data-name": "Path 137673",
    d: "M56.57,13.55Z",
    transform: "translate(-17.727 -7.34)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137674",
    "data-name": "Path 137674",
    d: "M12.44,45.2H12.6C12.962,45.27,12.713,45.239,12.44,45.2Z",
    transform: "translate(-7.982 -14.329)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137675",
    "data-name": "Path 137675",
    d: "M11.42,23.38,11.35,24A2.283,2.283,0,0,0,11.42,23.38Z",
    transform: "translate(-7.742 -9.511)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137676",
    "data-name": "Path 137676",
    d: "M39.93,49.22Z",
    transform: "translate(-14.052 -15.216)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137677",
    "data-name": "Path 137677",
    d: "M11.313,24.18c-.047.281-.1.608-.133.888C11.242,24.733,11.281,24.445,11.313,24.18Z",
    transform: "translate(-7.704 -9.687)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137678",
    "data-name": "Path 137678",
    d: "M72.26,22.87h0a.4.4,0,0,1,0,.085.3.3,0,0,1,0-.085Z",
    transform: "translate(-21.191 -9.398)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137679",
    "data-name": "Path 137679",
    d: "M72.205,23a.78.78,0,0,1-.085.179A.78.78,0,0,0,72.205,23Z",
    transform: "translate(-21.16 -9.427)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137680",
    "data-name": "Path 137680",
    d: "M72.3,22.56Z",
    transform: "translate(-21.2 -9.33)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137681",
    "data-name": "Path 137681",
    d: "M72.378,22l-.078.45a3.243,3.243,0,0,0,.078-.45Z",
    transform: "translate(-21.2 -9.206)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137682",
    "data-name": "Path 137682",
    d: "M70.866,16.9a2.923,2.923,0,0,0-.3-.623,1.5,1.5,0,0,0-.562-.522,2.041,2.041,0,0,1,.826,1.107Z",
    transform: "translate(-20.694 -7.825)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137683",
    "data-name": "Path 137683",
    d: "M13.209,11.933,13.2,11.66l-.1.818Z",
    transform: "translate(-8.128 -6.922)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137684",
    "data-name": "Path 137684",
    d: "M23.88,21.06a.187.187,0,0,0,.148,0h-.07s-.056.056,0,.078S23.9,21.06,23.88,21.06Z",
    transform: "translate(-10.508 -8.998)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137685",
    "data-name": "Path 137685",
    d: "M24.11,21.31Z",
    transform: "translate(-10.559 -9.054)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137686",
    "data-name": "Path 137686",
    d: "M24.637,19.57H24.59C24.629,19.57,24.614,19.609,24.637,19.57Z",
    transform: "translate(-10.665 -8.669)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137687",
    "data-name": "Path 137687",
    d: "M24.11,21.32Z",
    transform: "translate(-10.559 -9.056)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137688",
    "data-name": "Path 137688",
    d: "M27.77,22.24h.047Z",
    transform: "translate(-11.367 -9.259)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137689",
    "data-name": "Path 137689",
    d: "M24,21.15Z",
    transform: "translate(-10.535 -9.018)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137690",
    "data-name": "Path 137690",
    d: "M24.52,19.89Z",
    transform: "translate(-10.649 -8.74)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137691",
    "data-name": "Path 137691",
    d: "M23.94,21.15h.008Z",
    transform: "translate(-10.521 -9.018)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137692",
    "data-name": "Path 137692",
    d: "M26.7,18.906l.008-.016Z",
    transform: "translate(-11.131 -8.519)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137693",
    "data-name": "Path 137693",
    d: "M24.3,21.93Z",
    transform: "translate(-10.601 -9.19)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137694",
    "data-name": "Path 137694",
    d: "M26,23.177Z",
    transform: "translate(-10.976 -9.471)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137695",
    "data-name": "Path 137695",
    d: "M27.63,22.39Z",
    transform: "translate(-11.336 -9.292)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137696",
    "data-name": "Path 137696",
    d: "M24.094,21.14Z",
    transform: "translate(-10.558 -9.016)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137697",
    "data-name": "Path 137697",
    d: "M24.125,21.452V21.39h0S24.086,21.445,24.125,21.452Z",
    transform: "translate(-10.558 -9.071)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137698",
    "data-name": "Path 137698",
    d: "M25.59,23.019l-.008-.039-.024.047Z",
    transform: "translate(-10.878 -9.422)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137699",
    "data-name": "Path 137699",
    d: "M30.265,21.179c-.062-.039,0-.047-.109-.085s0-.047.047-.039,0-.047,0-.062a.1.1,0,0,0,0,.133.056.056,0,0,1-.047,0A.148.148,0,0,0,30.265,21.179Z",
    transform: "translate(-11.884 -8.984)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137700",
    "data-name": "Path 137700",
    d: "M30.26,21.66Z",
    transform: "translate(-11.917 -9.13)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137701",
    "data-name": "Path 137701",
    d: "M29.43,18.22v.045S29.492,18.282,29.43,18.22Z",
    transform: "translate(-11.733 -8.371)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137702",
    "data-name": "Path 137702",
    d: "M30.25,21.682Z",
    transform: "translate(-11.915 -9.137)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137703",
    "data-name": "Path 137703",
    d: "M23,23.662a.164.164,0,0,0,0-.062h0Z",
    transform: "translate(-10.314 -9.559)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137704",
    "data-name": "Path 137704",
    d: "M30.23,21.33Z",
    transform: "translate(-11.91 -9.058)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137705",
    "data-name": "Path 137705",
    d: "M22.577,18.42h0c0,.179-.327.3-.288.476h0v.156c0,.062,0-.047-.07,0,0,.179-.085.242-.062.382-.169.078-.062.359-.156.491h.039v.07c0,.024,0-.039.047,0a7.737,7.737,0,0,0,0,.95c0,.109.2,0,.148.169h-.07c.141.2.156.444.327.618h-.046c-.008,0,.086.156.117.133s0,0,0,.056.109.07.093.117h0s.078.117.109.062c0,.085.109.117.133.187s.07.125.148.078c-.07.056.047.164.117.164s0,.056,0,.062.1.07.125,0c0,.156.225.07.2.218l.476.179c-.047.078-.156-.078-.2,0,.148.056.265,0,.39.1s0,0-.056,0a1.769,1.769,0,0,0,.421.109h.07c0-.07.133-.093.148-.125-.078.1.117.062,0,.187a.07.07,0,0,0,.047-.047v.056c.1,0,.078-.047.156,0s0,0,0,.039a.2.2,0,0,1,.164,0h0c.125,0,.218-.078.343,0-.039.078.047,0,.056.1h.078c.062,0,.117-.062.169,0h0c.062-.039,0-.085.078-.07s.062,0,.093,0h0s.056-.056.1-.047,0,.085,0,.1.148-.039.169-.117a.164.164,0,0,0,0,.062v-.056a.041.041,0,0,1,.039.047c0,.047-.047-.078.062-.07h0c.109,0,.187-.078.281-.093s-.07.047,0,.093.242-.179.366-.225h0c0-.1.117,0,.156-.078s0,.062,0,.056a.9.9,0,0,0,.242-.225h0c.056,0,.117-.07.169-.1s0-.047,0-.062c.234,0,.2-.281.4-.312v.039l.078-.117H27.9a.1.1,0,0,1,0-.093c0,.062.056.047.086.039h0c.109,0-.062-.062.039-.109h0v-.039c0,.024,0-.141.056-.156a.273.273,0,0,1,0,.085c.086,0,.07,0,.1-.056h0l.07-.062h0c-.085-.133.056-.133,0-.257,0,.117,0,0,.085.07s.056-.039.062,0,.07-.056,0-.141,0,0,.062,0H28.4c-.056,0,.148-.164.109-.312a1.257,1.257,0,0,1-.062-.25h0l.056.039a.156.156,0,0,0,.039-.141h.047c.047,0-.062-.039,0-.085l.07.056a.911.911,0,0,0-.047-.156c-.008-.047,0,0,.062.056a.73.73,0,0,0,0-.125c0,.047,0,.062-.047.062v-.039c-.117,0,0,.148,0,.218h-.07a2.979,2.979,0,0,0,.056-.53h.156a.109.109,0,0,0,.1-.078l-.056-.085h.039v.07c.039-.047,0-.07,0-.093a.078.078,0,0,0,.047-.039l-.093-.078H28.9c.016,0-.07.047-.109,0s.07-.039,0-.078h.047c0-.039,0-.109-.078-.125s-.039-.133.047-.148a.2.2,0,0,1-.093-.085c.117.039,0-.141.078-.156-.1,0-.1-.164-.179-.234h0v-.117c0-.039-.125-.039-.187-.062s.093,0,.156-.047c-.056,0-.109-.078-.141,0s0-.047.047-.1c-.093.039-.039,0-.109-.039s.07-.062,0-.109.07,0,.07,0h-.11c-.039,0,0-.07,0-.117s-.125-.039-.148-.078h0s-.109-.148-.21-.156a.3.3,0,0,1-.07.07s-.078,0-.047-.056,0,0,.047,0H27.86c0-.07.056,0,.093,0s-.164-.056-.187-.109.1.078.1,0v.071c0-.117,0,.047.07-.078s-.109-.07-.179-.164,0,.047-.07.056c-.164-.056,0-.2-.133-.218s-.109.07-.148,0l.07-.047c-.085-.07-.117.047-.179-.056s.085,0,.078,0h-.109v-.061a3.663,3.663,0,0,0-.351-.133s.047,0,0-.056a1.737,1.737,0,0,1-.444-.234H26.4V17.3c0-.039,0,0-.056.047s0-.039,0-.056a.623.623,0,0,1-.411-.043h0c-.086,0-.117.1-.187.039h0a2.727,2.727,0,0,1-.538-.07c0,.085-.2,0-.2.093-.109-.039-.085-.062-.242-.078s-.047.085-.093.109v-.062l-.047.078-.056-.056h0a.179.179,0,0,1-.2,0l-.148.109.039-.062c.039-.062-.039-.056-.1,0s0,0,0,.047-.141,0-.2.07v-.039a2.018,2.018,0,0,0-.366.225.056.056,0,0,1,.056.085l-.056-.047c0,.047.056,0,0,.062s-.07-.039-.056-.07h0c0-.056-.125,0-.117.1h0a1.41,1.41,0,0,0-.242.242c.039.039,0,.062,0,.117a.982.982,0,0,0-.234.179v.093c0,.047-.1.056-.093,0a.834.834,0,0,0-.148.288h.056C22.779,18.708,22.592,18.435,22.577,18.42Zm.982,1.683h.062a.148.148,0,0,0,.109-.039l-.056-.047h.047v.039c.039,0,0-.039,0-.056h.047l-.085-.056h.078a.092.092,0,0,0-.047-.078c-.047-.024,0-.07.085-.056a.1.1,0,0,1-.056-.07c.085.062,0-.07.125,0-.085-.047,0-.093-.039-.156h.07c.024,0-.07-.078-.1-.125.085,0,.07.062.141.078-.056,0,0-.07-.078-.086a.169.169,0,0,1,.085,0c-.078-.047,0,0-.047-.07s.085,0,.078,0a.039.039,0,0,1,.039,0,.242.242,0,0,0-.07-.056c0-.056.056,0,.093,0s-.047-.093,0-.109h0c0-.056.047-.07,0-.148h0l-.078-.056h0c.062,0,0,.039.039.07s0-.109,0-.125,0,.07.039.078h-.047c.1.047,0,0,.078.07s0-.07.07-.093,0-.039-.056-.07.156.078.141,0-.062-.109,0-.1v.07c.047,0,0-.109,0-.1v.031c.047-.039.078-.117.133-.156a.056.056,0,0,0,0,.056A.265.265,0,0,1,24.8,18.6v-.062h0v-.016c0,.047.133-.141.2-.085h0c.039,0,0-.117.078-.078h0c.1,0,.21-.039.288.056,0-.085.085.039.109-.07.047.062,0,.078.093.133s.047-.062.078-.07v.056l.047-.047v.07h0a.047.047,0,0,1,0-.047.074.074,0,0,1,.062.093l.133.07h-.039c-.039,0,0,.062.039,0h0a.085.085,0,0,0,.085.062V18.7a.566.566,0,0,1,.2.078c.062.031,0-.085.056-.078v.056l.047-.056c.047-.056,0,.07-.047.078h.043l-.039.039c-.039.039,0,.085.062.047h0c.056.039.085.047.133.085s.056,0,.093-.039,0,.117.062.148.039,0,.078,0,0,.07-.047.07a.491.491,0,0,0,.133.1h0v.047h0c.117.047,0,.25.085.273h0l.078.047c0,.039-.047,0-.07,0,.117.047,0,.125.1.169-.141.078.039.179-.056.257h.093c.047.156-.062.312-.125.444s.164.078.07.125l-.062-.039c.047.133-.078.21-.07.337h0l-.117.047h0v.07h0s-.047.056,0,.078,0,.078-.078.085-.07,0,0,.093c-.062-.062-.1,0-.093.056s-.039,0-.056-.039,0,.047,0,.078c-.1,0,0,.141-.141.056a.592.592,0,0,1-.164.218c0-.078.078-.056,0-.133-.039.078-.056.156-.133.169s0-.039,0-.056-.141.047-.187.117h0s-.039,0,0,.039h0c.039.047,0,.133,0,.164,0-.117-.078,0-.07-.164a.062.062,0,0,0,0,.056v-.047c0-.047,0,.062-.062.07s0,0,0-.047,0,.078-.07.07h0s-.109.117-.187.085,0,0,0-.1h-.039s-.062.047-.093,0h-.031c-.039,0,0,.085-.056.07s0,0-.047-.056h0s-.039.047-.07,0,0-.078,0-.093-.078,0-.117.062a.124.124,0,0,0,0-.062v.047a.047.047,0,0,1,0-.056c-.047,0,0,.093-.056.039h0a.333.333,0,0,1-.164-.039c-.047-.039.056,0,.056-.07s-.179,0-.242,0h0c-.056.085,0-.07-.078-.047s.039-.039,0,0-.1,0-.187-.047h0c0-.039-.056-.062-.078-.085s0,0-.047,0c0-.169-.21-.062-.179-.225h0l-.07-.039v.062a.07.07,0,0,1-.07,0c.047,0,.056-.047.062-.078h0s-.078.056-.07,0h0c.031,0-.117,0-.085-.047h.047v-.078h0v-.031c-.141.039-.07-.056-.169-.062h.1a.117.117,0,0,1,.039-.047c-.056,0,0-.047-.062-.047s0,0,.039-.039,0,0-.056,0,.039-.133-.07-.164a.225.225,0,0,1-.148-.086h0a.117.117,0,0,1,.062,0,.07.07,0,0,0,0-.085H23.6s-.07,0-.047-.039h.078l-.078-.187h.078a.21.21,0,0,0-.056-.062s0,.039,0,.047h0c-.109.039,0,.085,0,.125h-.1a2.338,2.338,0,0,1,0-.327h.078ZM24.509,18.606Zm.047-.078h0s-.008,0,0-.008Zm-1.068,1.917Zm.062.234h.008Zm.46.779h.039V21.5Zm3.442.85v-.04h0Zm.779-1.231h-.062v-.062a.078.078,0,0,1,.065.062Zm.109-.366a.07.07,0,0,1-.056,0,.217.217,0,0,0,0-.07ZM26.781,17.281Zm-.078,0Z",
    transform: "translate(-10.093 -8.15)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137706",
    "data-name": "Path 137706",
    d: "M30.16,21.32h0Z",
    transform: "translate(-11.895 -9.056)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137707",
    "data-name": "Path 137707",
    d: "M25.3,16.828v.008l.016-.016Z",
    transform: "translate(-10.822 -8.062)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137708",
    "data-name": "Path 137708",
    d: "M29.84,22.81Z",
    transform: "translate(-11.824 -9.385)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137709",
    "data-name": "Path 137709",
    d: "M25,24.88Z",
    transform: "translate(-10.756 -9.842)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137710",
    "data-name": "Path 137710",
    d: "M26.689,24.87a.078.078,0,0,1-.039,0S26.7,24.9,26.689,24.87Z",
    transform: "translate(-11.12 -9.839)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137711",
    "data-name": "Path 137711",
    d: "M23.34,23.994Z",
    transform: "translate(-10.389 -9.649)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137712",
    "data-name": "Path 137712",
    d: "M30.31,21.33l.008.016v-.008Z",
    transform: "translate(-11.928 -9.058)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137713",
    "data-name": "Path 137713",
    d: "M30.236,21.83h0s-.07.07-.039.1S30.236,21.869,30.236,21.83Z",
    transform: "translate(-11.901 -9.168)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137714",
    "data-name": "Path 137714",
    d: "M27.465,24.75H27.42Z",
    transform: "translate(-11.29 -9.813)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137715",
    "data-name": "Path 137715",
    d: "M24.84,28.34Z",
    transform: "translate(-10.72 -10.606)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137716",
    "data-name": "Path 137716",
    d: "M28.989,30s-.093,0,0,.056S28.989,30,28.989,30Z",
    transform: "translate(-11.627 -10.972)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137717",
    "data-name": "Path 137717",
    d: "M24.82,28.33Z",
    transform: "translate(-10.716 -10.604)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137718",
    "data-name": "Path 137718",
    d: "M20.73,33.57l.047.047Z",
    transform: "translate(-9.812 -11.761)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137719",
    "data-name": "Path 137719",
    d: "M25.28,28.23v.056c0,.016.047,0,.056,0Z",
    transform: "translate(-10.818 -10.582)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137720",
    "data-name": "Path 137720",
    d: "M25.274,28.3Z",
    transform: "translate(-10.819 -10.597)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137721",
    "data-name": "Path 137721",
    d: "M31.06,34.938l.016.008-.008-.016Z",
    transform: "translate(-12.094 -12.061)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137722",
    "data-name": "Path 137722",
    d: "M23.29,28.4Z",
    transform: "translate(-10.378 -10.619)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137723",
    "data-name": "Path 137723",
    d: "M18.42,33Z",
    transform: "translate(-9.302 -11.635)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137724",
    "data-name": "Path 137724",
    d: "M19.039,31A.132.132,0,0,1,19,31Z",
    transform: "translate(-9.43 -11.193)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137725",
    "data-name": "Path 137725",
    d: "M20.18,33.48h0l.008.008Z",
    transform: "translate(-9.691 -11.74)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137726",
    "data-name": "Path 137726",
    d: "M25.266,28.388V28.38l-.016.008Z",
    transform: "translate(-10.811 -10.615)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137727",
    "data-name": "Path 137727",
    d: "M24.6,28.344h0s-.1-.047-.133,0S24.546,28.36,24.6,28.344Z",
    transform: "translate(-10.636 -10.602)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137728",
    "data-name": "Path 137728",
    d: "M19.69,30.261l.056-.008L19.73,30.2Z",
    transform: "translate(-9.583 -11.015)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137729",
    "data-name": "Path 137729",
    d: "M16.793,31.571v.109a.234.234,0,0,0,.078-.218h.039c.039,0,0-.148-.1-.133s0,.078.056.164S16.816,31.587,16.793,31.571Z",
    transform: "translate(-8.937 -11.266)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137730",
    "data-name": "Path 137730",
    d: "M17.119,30.66a.1.1,0,0,0,0,.047h0Z",
    transform: "translate(-9.014 -11.118)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137731",
    "data-name": "Path 137731",
    d: "M19.042,35.473v-.056S18.893,35.45,19.042,35.473Z",
    transform: "translate(-9.425 -12.168)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137732",
    "data-name": "Path 137732",
    d: "M17.14,30.64Z",
    transform: "translate(-9.02 -11.114)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137733",
    "data-name": "Path 137733",
    d: "M30.8,28.78a.163.163,0,0,0,0,.085h0Z",
    transform: "translate(-12.033 -10.703)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137734",
    "data-name": "Path 137734",
    d: "M16.986,31.24h-.047c-.008,0,0,.062,0,.078Z",
    transform: "translate(-8.975 -11.246)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137735",
    "data-name": "Path 137735",
    d: "M17,31.21Z",
    transform: "translate(-8.989 -11.239)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137736",
    "data-name": "Path 137736",
    d: "M29.464,32.059h0v-.125c0-.047,0,.07-.047,0a14.4,14.4,0,0,0-.312-1.559c-.07-.187-.21,0-.234-.288h.085A7.169,7.169,0,0,0,28.3,29.2h.062c0-.1-.179-.25-.21-.225s0,0,0-.07-.169-.117-.164-.187h.039c-.056,0-.164-.2-.169-.117-.07-.125-.2-.187-.257-.288s-.164-.187-.234-.141c.07-.062-.141-.218-.242-.25.039,0-.039-.07,0-.07-.078-.07-.164-.109-.179-.062-.093-.2-.359-.156-.374-.327-.281-.133-.538-.242-.779-.343.047-.078.273.133.3.047a5.115,5.115,0,0,1-.639-.21h.078a4.559,4.559,0,0,0-.7-.225h.056c-.047,0-.1-.047-.1,0h.039c.056.07-.2.062-.218.085.1-.085-.21-.085-.056-.2,0,0-.07,0-.07.039s-.056-.039,0-.056h-.265a.061.061,0,0,0,.056-.039.46.46,0,0,1-.273,0h0a3.941,3.941,0,0,1-.6,0c.078-.078-.07-.039-.078-.117h-.39c-.117,0,0,.093-.141.07a.3.3,0,0,1-.164-.047h0a.288.288,0,0,1-.187,0v-.093c0-.016-.257,0-.319.1s0-.062,0-.062l-.039.047c-.047,0-.062,0-.056-.047-.148,0,.056.085-.125.062h0c-.179,0-.343.07-.506.078s.141-.039.07-.093c-.234.047-.476.179-.7.218h.047c0,.1-.187,0-.281.078s0-.062,0-.056a1.94,1.94,0,0,0-.522.25v-.039c-.1,0-.234.093-.337.117s-.07.062,0,.078c-.351,0-.483.359-.779.4,0,0,.056-.062,0-.047l-.179.156h.1a.374.374,0,0,1-.1.133c.07-.085-.047-.062-.093-.056s0,0,0,.039c-.148,0,0,.085-.133.141h0a.7.7,0,0,1-.117.148c-.056,0,0-.062,0-.1s-.078.2-.179.218l.085-.117a.25.25,0,0,0-.164.078h0l-.133.093h0c0,.179-.156.187-.21.366.047-.169,0-.056-.047-.1s-.1.047-.1,0c0,.093-.109.07-.133.2,0,0-.056.056-.078,0-.056.085.039,0,.056,0-.056.156-.3.234-.351.468a3.452,3.452,0,0,0-.093.39h0c-.047,0,0-.078,0-.078a.413.413,0,0,0-.125.218h-.062c-.062,0,0,.078,0,.148a.25.25,0,0,1-.039-.1.532.532,0,0,1-.047.265c-.047.085,0-.07,0-.109a2.187,2.187,0,0,0-.047.218.1.1,0,0,1,.085-.1v.066c.125,0,.085-.234.156-.343l.039.07a4.979,4.979,0,0,0-.359.881h0l-.085-.039-.056-.056v.085h0c-.039,0-.085,0-.141.109V30.9l-.056.039v-.117c-.056.056,0,.109,0,.164a.07.07,0,0,0-.056.047l.056.156s-.056-.078-.093,0,.093-.056.1.056-.078.047-.056.125,0,0-.039-.039,0,.2.047.234,0,.257-.062.265a.779.779,0,0,1,.109.187c-.133-.1.07.265,0,.265.109.062.2.312.351.413H16.6s.056.117.085.179.179.047.273.056c.047.133-.109,0-.125.109,0-.056.2.07.2,0,.056.085.056.062.062.141.062-.078.086,0,.179,0s0,.093.148.117-.078.039-.078.039c.148.047.085-.047.133-.078.169,0,.062.07.117.125h.085a.546.546,0,0,1,.179,0h0a1.316,1.316,0,0,0,.428,0h0a.133.133,0,0,1,0-.093h.133c0,.078-.085,0-.093.062a1.075,1.075,0,0,1,.351,0c0,.07-.21,0-.1.07l-.141-.047c.093.117-.078,0,0,.1s.21,0,.39.047c.047,0,0-.056.039-.085.273,0,.179.2.382.141.062,0,.093-.117.218-.056l-.056.07c.169,0,.117-.093.3,0h.062v.062h.618s-.056,0,0,.056a3.117,3.117,0,0,1,.779.179l.109-.047h0c.093,0,0,0,.062-.047s.07.047,0,.056a1.558,1.558,0,0,1,.686.062h0c.141.047.187-.093.312,0h0a4.2,4.2,0,0,1,.881.2c.062-.078.3.086.343,0a1.387,1.387,0,0,0,.359.179c.062,0,.109-.056.2-.056v.056h.125l.047.078h.078s-.062-.039-.056-.056a.382.382,0,0,1,.288.117h.2c.164,0,0,.07.164,0v-.051a.826.826,0,0,0,.343.078h0c.21.047.45.056.694.093-.085,0-.056-.1,0-.1v.07c.056,0-.062,0,0-.07s.056.085,0,.093H26.1v.047c0,.047.169.093.25,0h0a1.5,1.5,0,0,1,.545.062c0-.056.086,0,.156-.07a1.247,1.247,0,0,0,.514.085c.141-.039,0-.047.093-.085s.21,0,.117.062a1.349,1.349,0,0,0,.545-.25h.056c.234-.2.694-.4.731-.709h0a1.753,1.753,0,0,0,.07-.273c.047-.117,0,.085.062,0a2.7,2.7,0,0,0,.078-.7C29.574,32.737,29.395,32.316,29.464,32.059Zm-6.342-4.286h-.2v-.056Zm-.25,0a.047.047,0,0,1,0-.056h.078Zm-2.4.4-.039.047h0Zm6.881,2.338-.039-.078h.039c.039,0,0,.093,0,.125Zm-.093-.169h0V30.3ZM23.714,27.8a.281.281,0,0,0,0,.085h0l-.039.056h.062a.148.148,0,0,0,.078.125h.117v.047h-.085c.039.056.078,0,.125,0a.062.062,0,0,0,0,.056l.125-.056c0,.039-.062.056,0,.093s0-.093.062-.093,0,.078.078.062l-.039.039h.169c.039,0,.169.039.141.117a.319.319,0,0,1,.156,0c-.125.07.164.07.1.164.093-.056.225.056.351.062h-.039c.056.039.062.07.093.1s.133,0,.2-.047-.085.056-.093.133c0-.062.148,0,.148-.047v.117c.056-.078.056,0,.125,0,.056.093,0,.093.07.117s-.07,0-.07,0a.157.157,0,0,0,.117-.056c.039-.056,0,.07,0,.125s.148,0,.2.039h0a.787.787,0,0,0,.3.141h0a.337.337,0,0,1,.056-.078c.039,0,.093,0,.078.062a.047.047,0,0,0-.056,0h.047c0,.085-.062,0-.093,0,.085.039.2.07.234.133s-.133-.093-.1,0l-.062-.093c0,.133-.047-.047-.062.085s.141.078.218.187,0-.047.078-.047c.2.093,0,.225.156.273s.133-.047.164.062h-.085c.078.1.141,0,.187.133,0,0-.085-.07-.078-.047a1.1,1.1,0,0,0,.109.133v.078a4.389,4.389,0,0,1,.312.337H27.2a1.223,1.223,0,0,1,.225.562l.086.047h.07c.07,0,0,.07-.039.047a.724.724,0,0,1,.2.476h0c0,.109.141.093.117.2h0a1.559,1.559,0,0,1,0,.678c.093,0,0,.234.093.242-.056.141-.078.1-.117.281,0,0,.062.056.062.1H27.84a.281.281,0,0,1,0,.07h-.069c0,.078-.133.07-.141.039a.265.265,0,0,1-.1.078.337.337,0,0,1,0-.056c-.047.07,0-.062-.056,0a.086.086,0,0,1,0,.047.4.4,0,0,0-.257-.056h0a1.189,1.189,0,0,0-.483-.056c.062,0,.039.1,0,.1v-.07c-.039,0,.056,0,0,.07s-.039-.078,0-.093h-.093v-.047c0-.047-.133-.085-.2,0h-.428c0,.056-.07,0-.125.07a1.38,1.38,0,0,0-.359-.117c-.093,0,0,.039-.078.07s-.141-.07-.062-.093a2.253,2.253,0,0,0-.413,0s.039,0,0,.056-.078-.039-.07-.062h0c-.242.039-.506-.225-.7-.156h-.2c-.085,0,.056,0,0-.07-.218.056-.319-.062-.5,0-.109-.164-.46-.062-.623-.187v.039c-.056,0-.056,0-.085-.039s.047.039,0,.047a6.39,6.39,0,0,1-1.172-.27c-.141,0-.109.164-.281.056l.062-.056c-.3,0-.592-.093-.888-.078h.056c.056,0-.225-.039-.225,0v-.056c0-.056-.164,0-.187,0h0c-.039,0-.179-.039-.156,0-.1-.047-.2,0-.288-.056s-.169-.056-.2,0c0-.085-.179-.1-.25-.07s-.056,0,0-.07-.156,0-.148.047c-.125-.125-.3.039-.359-.109h-.657c0-.085.225,0,.234-.07-.2,0-.374.078-.421,0s0,0,.047,0c-.1,0-.062-.093-.085-.281h0v-.078h0c-.07.047-.1-.141-.133-.156.1.078.062-.156.187-.039,0,0,0-.056-.039-.056h.056c0-.117-.047-.085,0-.187s0,0,.039.047a.25.25,0,0,1,0-.21h0c.047-.148,0-.288.109-.428.056.078.056-.039.117,0v-.087h-.047c.039-.07,0-.156.085-.21v.07l.062-.141-.07.062c0-.093-.078-.039,0-.125s.056-.07.109-.078h0a.156.156,0,0,1,.062-.141s.056.062.078.062a.352.352,0,0,0,.078-.242c-.016-.078,0,.047.039.047v-.056h.07c.024,0-.1,0,0-.109v.039c.109-.093.156-.218.265-.288s-.062.085,0,.1a2.338,2.338,0,0,1,.359-.421h0c-.047-.093.133-.039.169-.133s0,.062,0,.047A1.683,1.683,0,0,0,19.8,28.6v.039c.07,0,.164-.085.234-.117s.047-.047,0-.07c.273,0,.366-.281.618-.242,0,0-.047.047,0,.039l.164-.085c0-.039,0,0-.086-.039a.187.187,0,0,1,.1-.085c-.07.056,0,.07.062.085s0,0,0-.047c.109.047,0-.093.125-.078h0a.78.78,0,0,1,.133-.078h0c0,.047-.047.039,0,.085s.117-.133.2-.1l-.1.056a.218.218,0,0,0,.148,0h.1c.056-.156.169-.07.281-.169-.109.1,0,.047,0,.109s.085,0,.07.039.1,0,.169-.056.062,0,.056.047,0,0,0-.056.273.047.428-.047a.764.764,0,0,1,.281-.117h0l-.047.062a.359.359,0,0,0,.2,0v.056c0,.056.039-.07.109-.039a.234.234,0,0,1-.056.078,1.815,1.815,0,0,1,.2-.056.3.3,0,0,1-.07.062h.164a.056.056,0,0,1-.085-.047h.047a.062.062,0,0,0-.039-.039h.265a.1.1,0,0,0-.078.133c.047-.062.056,0,.117-.1s.062,0,.047.056.056,0,.085,0a.117.117,0,0,0-.169-.039s0,0,0-.039h.258Zm-1.379-.085h.047ZM19.3,27.363a.078.078,0,0,1,0,.039l-.07.039s.031.008.07-.031Zm-1.886,1.714h.062a.591.591,0,0,0-.062.086.148.148,0,0,1,0-.039Zm-.366.569a.056.056,0,0,1,.056,0,.475.475,0,0,0-.056.109ZM20.5,33.667Zm.141,0h0a.1.1,0,0,1,.078.047Z",
    transform: "translate(-8.807 -10.171)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137737",
    "data-name": "Path 137737",
    d: "M26.474,36.666V36.65l-.024.008Z",
    transform: "translate(-11.076 -12.441)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137738",
    "data-name": "Path 137738",
    d: "M18.37,29Z",
    transform: "translate(-9.292 -10.751)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137739",
    "data-name": "Path 137739",
    d: "M27.35,26.82h0C27.412,26.828,27.381,26.82,27.35,26.82Z",
    transform: "translate(-11.274 -10.27)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137740",
    "data-name": "Path 137740",
    d: "M24.49,26.516h.07S24.49,26.485,24.49,26.516Z",
    transform: "translate(-10.643 -10.2)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137741",
    "data-name": "Path 137741",
    d: "M30.24,28.3h0l.016.008Z",
    transform: "translate(-11.913 -10.597)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137742",
    "data-name": "Path 137742",
    d: "M16.876,31.16l-.016.016.008.008Z",
    transform: "translate(-8.958 -11.229)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137743",
    "data-name": "Path 137743",
    d: "M17.357,30.23a.429.429,0,0,0-.117.141h0C17.24,30.339,17.365,30.285,17.357,30.23Z",
    transform: "translate(-9.042 -11.023)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137744",
    "data-name": "Path 137744",
    d: "M23.13,26.558l.093-.031-.07-.024Z",
    transform: "translate(-10.342 -10.201)",
    fill: "#0c3058"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13318",
    "data-name": "Path 13318",
    d: "M.111,2.9c.161,0-.08.111,0,.185s-.087,0-.068,0S.08,3.3.13,3.45H.093c-.037.062,0,.161-.043.223s.037.056.1.037c-.241.2.124.383-.074.562,0,0-.037-.049-.037-.037l.037.155c.074,0,.043,0,.1-.049a.13.13,0,0,1,.08.1C.2,4.371.136,4.439.1,4.47s.043,0,.068,0c-.13.08.136,0,.056.124H.2c0,.043.074.08.068.124S.223,4.68.155,4.68s.173.105.1.173-.037-.062-.062-.08c-.087.074-.062.08-.068.136h0V5c.229,0,.093.161.266.2-.167-.037-.074,0-.167.049s0,.093-.043.093c.093,0,0,.117.13.13,0,0,.031.049-.037.08C.334,5.6.3,5.509.34,5.5c.142,0,.062.3.291.309a.8.8,0,0,0,.321,0h0c0,.049-.08.062-.08.062a.13.13,0,0,0,.148.093v.08c0,.037.08-.08.124,0a.352.352,0,0,1-.1.093A.446.446,0,0,0,1.261,6.1c.068-.037-.062.062-.093.087a.371.371,0,0,0,.161,0c-.068,0-.068-.056-.062-.087h.049c0-.179-.173,0-.253-.074l.074-.087a1.421,1.421,0,0,0,.618.136h0a1.2,1.2,0,0,0,0,.148h0l-.031.1H1.78a.235.235,0,0,0,.093.173L1.959,6.4v.068H1.885c.043.062.068,0,.1-.037a.142.142,0,0,0,.037.08l.093-.142c0,.062-.043.117,0,.148.043-.068-.043-.13,0-.173.043.068.031.124.087.068a.074.074,0,0,1,0,.074c.043-.043.117,0,.142-.093.043.08.148,0,.148.111A.253.253,0,0,1,2.608,6.4c-.074.161.155,0,.136.185.056-.148.2-.068.3-.148v.031c0-.006.068.056.105.08,0-.117.093-.148.142-.223.068.117-.043.142,0,.253,0-.1.117-.1.093-.179.056.074.043.037.074.136,0-.148.049,0,.093-.117.074.074,0,.142.1.093.043.049-.031.105-.031.105s.037-.117.056-.179.049.08.08.142c.062-.031.111-.136.161-.13s0,0,0,.049c.068-.093.2,0,.278-.117a.7.7,0,0,1,0-.155c.043,0,.074-.074.087,0s0,0-.037.056l.043-.037c0,.111-.056.037-.056.117.074-.037.167-.124.229-.093s-.142.037-.062.13l-.093-.043c.074.167-.056,0,0,.167.117.031.13-.056.253,0V6.38c.173-.105.136.266.26.124,0-.068.043-.2.136-.13l-.031.117c.117,0,.068-.173.192-.093,0,.049-.093.043-.074.056s.056-.068.117-.068l-.019-.049a3.881,3.881,0,0,0,.4-.111v.093a4.822,4.822,0,0,1,.68-.049.661.661,0,0,0,.043-.117A.039.039,0,0,1,6.3,6.2c-.006.049,0-.056,0-.105s.074,0,.062.056c.105-.13.247-.34.414-.371v.037c.111-.056-.049-.223.08-.241h0c.2-.167.235-.439.42-.575-.111-.068.117-.235-.068-.284.111-.117.136-.093.2-.278,0-.043-.111-.068-.13-.124h.093l-.1-.074L7.392,4.2V4.149a.08.08,0,0,1-.074.043c-.043-.08.068-.2.117-.2l-.093-.13c.037,0,.049.037.074.062-.1-.1.1,0,0-.111H7.343a.229.229,0,0,0,.031-.229h.068V3.135c-.031.056-.142.043-.155,0h.1c-.062,0-.037.049-.111,0s.111-.037.142,0V3.067H7.5c-.062,0,.105-.124,0-.167h.031c0-.155-.031-.229-.037-.358-.087,0-.068-.049-.142-.087a.927.927,0,0,0,.093-.315c-.043-.08-.074,0-.13-.062.08,0,.074-.124.13-.056a.785.785,0,0,0-.13-.414s-.031.056-.062.049A.074.074,0,0,1,7.3,1.565h0c-.087-.093-.074-.235-.087-.377S7.157.91,7.034.885h0C6.972.848,6.9.823,6.842.793s.08,0,.068-.087C6.669.657,6.663.465,6.465.446c0-.284-.451-.185-.618-.346V.156A.082.082,0,0,1,5.761.063c0-.019.043.056,0,.08A1.9,1.9,0,0,1,5.217.113C5.05.076,4.883.026,4.716,0s-.074.284-.223.155l.043-.1c-.247.117-.507,0-.748.1,0,0,0-.056.043-.056s-.192,0-.192.056S3.641.1,3.61.069s-.13.1-.155,0h0s-.155,0-.124.074c-.093-.037-.173.037-.247,0C3.041.242,2.93.1,2.917.236c0-.142-.161-.117-.216-.049C2.7.144,2.652.144,2.67.082s-.124,0-.111.105C2.441.02,2.318.317,2.25.106a2.917,2.917,0,0,1-.544.155c0-.136.192,0,.185-.161a1.236,1.236,0,0,1-.47.173c-.056,0,0-.068.031-.093-.185.08-.4.074-.525.223a.1.1,0,0,1,0-.049C.9.354.847.354.878.428V.4C.964.459.847.626.878.675.834.49.717.718.668.477a.1.1,0,0,0,0,.1A.057.057,0,0,1,.612.514c-.08.105,0,.124-.087.2V.632a.209.209,0,0,1-.087.21C.352.9.4.842.439.793c-.111.13-.049.3-.179.414-.093-.105-.068,0-.173,0v.105H.155c-.037.074,0,.167-.037.223V1.46a1.317,1.317,0,0,0,0,.155l.062-.068c.037.087.142.031.087.117,0,0,0,.068-.093.1h0c.031.043.062.08.031.136s-.124,0-.148,0c.093.043,0,.185.124.223a.309.309,0,0,0-.1,0l.08.031c0,.031-.037.037-.087.031,0,.1.142-.031.08.087H.124c-.031.117.049.229,0,.334s0-.093-.124-.056c0,.155.136.321.111.47ZM.729,4.365A.08.08,0,0,1,.8,4.408H.729Zm0-1.446A.2.2,0,0,1,.8,2.956H.729Zm0-.4.08.056a.167.167,0,0,1-.08,0ZM3.616,1.194H3.548V1.133l.062.062ZM3.467,1.194ZM.655,5.607l.037-.062.049.037a.142.142,0,0,1-.093.031Zm.365.278a.111.111,0,0,1,.037-.08l.062.031Zm4.531.321Zm.111,0V6.145A.448.448,0,0,0,5.73,6.2ZM.26,4.013v.049a.1.1,0,0,1-.074-.049.3.3,0,0,1,.074,0Z",
    transform: "translate(34.467 16.232) rotate(8)",
    fill: "#2d82f7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiometricId);
export default __webpack_public_path__ + "static/media/biometric-id.1eb219b90ae6da74c7ba421db6d84dad.svg";
export { ForwardRef as ReactComponent };